// This file was automatically generated from print.refPanel.html.
// Please don't edit this file by hand.

goog.provide('el8.template.print.refPanel');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.appchart.refpanel.maint');
goog.require('el8.template.print');
goog.require('el8.template.print.refPanel.meds');
goog.require('el8.template.ptdata.model.order.referral');
goog.require('el8.template.ptdata.ptAllergies');
goog.require('el8.template.ptdata.ptImmunizationDeclines');
goog.require('el8.template.ptdata.ptImmunizations');
goog.require('el8.template.ptdata.ptIntolerances');
goog.require('el8.template.ptdata.ptProblems');
goog.require('el8.template.ptdata.ptProviders');
goog.require('el8.template.ptdata.reports');
goog.require('el8.template.ptdata.smokingStatuses');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.refPanel.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="pageWrap pageBreak">');
  el8.template.print.header(opt_data, output);
  el8.template.print.currentAsOf(opt_data, output);
  output.append('<h1 class="documentTitle">Clinical Profile</h1>');
  el8.template.print.patientInfo(opt_data, output);
  if (opt_data.ptAllergies.items.length) {
    output.append('<h4>Allergies</h4><ul class="list">');
    var paList16734 = opt_data.ptAllergies.items;
    var paListLen16734 = paList16734.length;
    for (var paIndex16734 = 0; paIndex16734 < paListLen16734; paIndex16734++) {
      var paData16734 = paList16734[paIndex16734];
      output.append('<li class="preserve itemBullet">');
      el8.template.ptdata.ptAllergies.summary(paData16734, output);
      output.append('</li>');
    }
    output.append('</ul>');
  } else if (opt_data.ptAllergies.isDocumented) {
    output.append('<h4>Allergies</h4><p>');
    el8.template.ptdata.ptAllergies.documentedAsNoneSummary(null, output);
    output.append('</p>');
  }
  if (opt_data.ptIntols.items.length) {
    output.append('<h4>Drug Intolerances</h4><ul class="list">');
    var piList16747 = opt_data.ptIntols.items;
    var piListLen16747 = piList16747.length;
    for (var piIndex16747 = 0; piIndex16747 < piListLen16747; piIndex16747++) {
      var piData16747 = piList16747[piIndex16747];
      output.append('<li class="preserve itemBullet">');
      el8.template.ptdata.ptIntolerances.summary(piData16747, output);
      output.append('</li>');
    }
    output.append('</ul>');
  } else if (opt_data.ptIntols.isDocumented) {
    output.append('<h4>Drug Intolerances</h4><p>');
    el8.template.ptdata.ptIntolerances.documentedAsNoneSummary(null, output);
    output.append('</p>');
  }
  if (opt_data.ptProblems.items.length) {
    output.append('<h4>Problem List</h4><ol class="numberedList">');
    var ppList16760 = opt_data.ptProblems.items;
    var ppListLen16760 = ppList16760.length;
    for (var ppIndex16760 = 0; ppIndex16760 < ppListLen16760; ppIndex16760++) {
      var ppData16760 = ppList16760[ppIndex16760];
      output.append('<li class="preserve item">');
      el8.template.ptdata.ptProblems.summary(ppData16760, output);
      output.append('</li>');
    }
    output.append('</ol>');
  } else if (opt_data.ptProblems.isDocumented) {
    output.append('<h4>Problem List</h4><p>');
    el8.template.ptdata.ptProblems.documentedAsNoneSummary(null, output);
    output.append('</p>');
  }
  el8.template.print.refPanel.bulletedList({sectionTitle: 'Past Medical History', itemsList: opt_data.historyItems.past.items}, output);
  el8.template.print.refPanel.bulletedList({sectionTitle: 'Past Surgical History', itemsList: opt_data.historyItems.surgical.items}, output);
  if (opt_data.historyItems.family.items.length || opt_data.familyRelationships.length) {
    output.append('<h4>Family History</h4><ul class="list">');
    var relationshipList16779 = opt_data.familyRelationships;
    var relationshipListLen16779 = relationshipList16779.length;
    for (var relationshipIndex16779 = 0; relationshipIndex16779 < relationshipListLen16779; relationshipIndex16779++) {
      var relationshipData16779 = relationshipList16779[relationshipIndex16779];
      var itemList16780 = relationshipData16779.items;
      var itemListLen16780 = itemList16780.length;
      for (var itemIndex16780 = 0; itemIndex16780 < itemListLen16780; itemIndex16780++) {
        var itemData16780 = itemList16780[itemIndex16780];
        output.append('<li class="preserve itemBullet">', soy.$$escapeHtml(relationshipData16779.relationshipTypeName), ': ', soy.$$escapeHtml(itemData16780.textOrCodeDescription), '</li>');
      }
    }
    el8.template.print.refPanel.bulletedListContent({itemsList: opt_data.historyItems.family.items}, output);
    output.append('</ul>');
  }
  el8.template.print.refPanel.bulletedList({sectionTitle: 'Social History', itemsList: opt_data.historyItems.social.items}, output);
  el8.template.print.refPanel.bulletedList({sectionTitle: 'Cognitive', itemsList: opt_data.historyItems.cognitive.items}, output);
  el8.template.print.refPanel.bulletedList({sectionTitle: 'Functional', itemsList: opt_data.historyItems.functional.items}, output);
  el8.template.print.refPanel.bulletedList({sectionTitle: 'Psychological', itemsList: opt_data.historyItems.psychological.items}, output);
  el8.template.print.refPanel.bulletedList({sectionTitle: 'Habits', itemsList: opt_data.historyItems.habits.items}, output);
  if (opt_data.currSmokingStatus) {
    output.append('<h4>Cigs</h4><ul class="list"><li class="preserve itemBullet">');
    el8.template.ptdata.smokingStatuses.summary(opt_data.currSmokingStatus, output);
    output.append('</li></ul>');
  }
  el8.template.print.refPanel.bulletedList({sectionTitle: 'Diet', itemsList: opt_data.historyItems.diet.items}, output);
  el8.template.print.refPanel.bulletedList({sectionTitle: 'Exercise', itemsList: opt_data.historyItems.exercise.items}, output);
  if (opt_data.permRxThreads.length) {
    output.append('<h4>Permanent Rx Medications</h4><ol class="numberedList">');
    el8.template.print.refPanel.meds.permList({threads: opt_data.permRxThreads}, output);
    output.append('</ol>');
  }
  if (opt_data.permOtcThreads.length) {
    output.append('<h4>Permanent OTC Medications</h4><ol class="numberedList">');
    el8.template.print.refPanel.meds.permList({threads: opt_data.permOtcThreads}, output);
    output.append('</ol>');
  }
  if (opt_data.mainProviders.length) {
    output.append('<h4>Provider List</h4><ul class="list">');
    var itemList16832 = opt_data.mainProviders;
    var itemListLen16832 = itemList16832.length;
    for (var itemIndex16832 = 0; itemIndex16832 < itemListLen16832; itemIndex16832++) {
      var itemData16832 = itemList16832[itemIndex16832];
      output.append('<li class="preserve itemBullet">');
      el8.template.ptdata.ptProviders.summary(itemData16832, output);
      output.append('</li>');
    }
    output.append('</ul>');
  }
  if (opt_data.ptImmunizations.items.length || opt_data.ptImmunizationDeclines.items.length || opt_data.historyItems.immunization.items.length) {
    output.append('<h4>Immunizations</h4><ul class="list">');
    var itemList16841 = opt_data.ptImmunizations.items;
    var itemListLen16841 = itemList16841.length;
    for (var itemIndex16841 = 0; itemIndex16841 < itemListLen16841; itemIndex16841++) {
      var itemData16841 = itemList16841[itemIndex16841];
      output.append('<li class="preserve itemBullet">');
      el8.template.ptdata.ptImmunizations.summary(itemData16841, output);
      output.append('</li>');
    }
    var itemList16846 = opt_data.ptImmunizationDeclines.items;
    var itemListLen16846 = itemList16846.length;
    for (var itemIndex16846 = 0; itemIndex16846 < itemListLen16846; itemIndex16846++) {
      var itemData16846 = itemList16846[itemIndex16846];
      output.append('<li class="preserve itemBullet">');
      el8.template.ptdata.ptImmunizationDeclines.summary(itemData16846, output);
      output.append('</li>');
    }
    el8.template.print.refPanel.bulletedListContent({itemsList: opt_data.historyItems.immunization.items}, output);
    output.append('</ul>');
  }
  el8.template.print.refPanel.healthMaintenceList({itemsList: opt_data.historyItems.maintenance.items, hmReminders: opt_data.hmReminders}, output);
  if (opt_data.legalReports.length || opt_data.historyItems.legal.items.length) {
    output.append('<h4>Legal</h4><ul class="list">');
    var itemList16860 = opt_data.legalReports;
    var itemListLen16860 = itemList16860.length;
    for (var itemIndex16860 = 0; itemIndex16860 < itemListLen16860; itemIndex16860++) {
      var itemData16860 = itemList16860[itemIndex16860];
      output.append('<li class="preserve itemBullet">');
      el8.template.ptdata.reports.refPanelLegalReport(itemData16860, output);
      output.append('</li>');
    }
    el8.template.print.refPanel.bulletedListContent({itemsList: opt_data.historyItems.legal.items}, output);
    output.append('</ul>');
  }
  if (! opt_data.mainProviders.length && (opt_data.referralOrders.length || opt_data.historyItems.consultation.items.length)) {
    output.append('<h4>Specialists</h4><ul class="list">');
    var itemList16871 = opt_data.referralOrders;
    var itemListLen16871 = itemList16871.length;
    for (var itemIndex16871 = 0; itemIndex16871 < itemListLen16871; itemIndex16871++) {
      var itemData16871 = itemList16871[itemIndex16871];
      output.append('<li class="preserve itemBullet">');
      el8.template.ptdata.model.order.referral.refPanelSummary(itemData16871, output);
      output.append('</li>');
    }
    el8.template.print.refPanel.bulletedListContent({itemsList: opt_data.historyItems.consultation.items}, output);
    output.append('</ul>');
  }
  output.append('</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.refPanel.bulletedList = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.itemsList.length) {
    output.append('<h4>', soy.$$escapeHtml(opt_data.sectionTitle), '</h4><ul class="list">');
    el8.template.print.refPanel.bulletedListContent(opt_data, output);
    output.append('</ul>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.refPanel.healthMaintenceList = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.itemsList.length || opt_data.hmReminders && opt_data.hmReminders.length) {
    output.append('<h4>Health Maintenance</h4><ul class="list">');
    if (opt_data.hmReminders && opt_data.hmReminders.length) {
      var hmReminderList16894 = opt_data.hmReminders;
      var hmReminderListLen16894 = hmReminderList16894.length;
      for (var hmReminderIndex16894 = 0; hmReminderIndex16894 < hmReminderListLen16894; hmReminderIndex16894++) {
        var hmReminderData16894 = hmReminderList16894[hmReminderIndex16894];
        output.append('<li class="preserve itemBullet">');
        el8.template.appchart.refpanel.maint.reminderText(hmReminderData16894, output);
        output.append('</li>');
      }
    }
    el8.template.print.refPanel.bulletedListContent(opt_data, output);
    output.append('</ul>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.refPanel.bulletedListContent = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var itemList16902 = opt_data.itemsList;
  var itemListLen16902 = itemList16902.length;
  for (var itemIndex16902 = 0; itemIndex16902 < itemListLen16902; itemIndex16902++) {
    var itemData16902 = itemList16902[itemIndex16902];
    output.append((itemData16902.modelClass == 'ClinicalFormCollection') ? '<li class="preserve itemBullet">' + soy.$$escapeHtml(itemData16902.collectionSummary) + '</li>' : '<li class="preserve itemBullet">' + soy.$$escapeHtml(itemData16902.text) + '</li>');
  }
  if (!opt_sb) return output.toString();
};
